module.exports = __webpack_public_path__ + "static/media/logo_chameleon1.7196b67b.png";